import { ChevronRight, Globe, Server } from "lucide-react";

const traffic = [
  {
    id: 1,
    method: "GET",
    url: "https://example.com/api/user",
    host: "example.com",
    status: 200,
    time: "16:42:11",
    type: "json"
  },
  {
    id: 2,
    method: "POST",
    url: "https://shopdemo.site/auth/login",
    host: "shopdemo.site",
    status: 401,
    time: "16:42:15",
    type: "json"
  },
  {
    id: 3,
    method: "GET",
    url: "https://legacyapp.net/vuln",
    host: "legacyapp.net",
    status: 500,
    time: "16:43:01",
    type: "html"
  },
  {
    id: 4,
    method: "PUT",
    url: "https://example.com/profile/edit",
    host: "example.com",
    status: 204,
    time: "16:43:17",
    type: "json"
  }
];

export default function TrafficList({ onSelect, selectedId }: {
  onSelect: (id: number) => void;
  selectedId: number | null;
}) {
  return (
    <div className="bg-card rounded-l-xl border border-border border-r-0 min-w-[275px] max-w-xs w-full flex flex-col overflow-y-auto">
      <div className="font-bold px-5 py-4 border-b border-border sticky top-0 bg-card z-10">Traffic</div>
      <div className="flex-1 overflow-auto">
        {traffic.map(t => (
          <button
            key={t.id}
            onClick={() => onSelect(t.id)}
            className={`w-full flex items-center text-left px-4 py-3 border-b border-border gap-3 hover:bg-accent transition text-sm focus:outline-none ${selectedId === t.id ? 'bg-accent' : ''}`}
          >
            <span className="font-mono text-xs px-2 py-0.5 rounded bg-muted mr-1">{t.method}</span>
            <span className="truncate flex-1 text-foreground">{t.url}</span>
            <span className={`text-xs font-bold ${t.status >= 400 ? 'text-destructive' : 'text-green-600 dark:text-green-400'}`}>{t.status}</span>
            <ChevronRight size={16} className="opacity-40 ml-2" />
          </button>
        ))}
      </div>
    </div>
  );
}
